














import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
    data() {
        return {
            baseUrl: process.env.BASE_URL,
        };
    },
})
export default class ImageText extends Vue {
    @Prop({
        type: String,
        required: true,
    })
    private image!: string;

    @Prop({
        type: Boolean,
        required: true,
    })
    private odd!: boolean;
}
